import { ReportDesignerComponent } from './../../../reports/report/designer/reportdesigner.component';
import { SecurityService } from '../../../../../services/security.service';
import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { WindowState } from '@progress/kendo-angular-dialog';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { ComponentBase } from '~/infrastructure/component-base';
import { LabelPreset } from '~/models/modules/labelPreset';
import { ReportsService } from '~/services/modules/reports/reports';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { LabelService } from '~/services/modules/stocks/labels';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { LabelType } from '~/shared/enums/label-type.enum';
import { orderBy } from "@progress/kendo-data-query";
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'app-barcode-label-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BarcodeLabelUpsertComponent extends ComponentBase implements OnDestroy, OnInit {

  _pageState: PageState;
  _active: boolean;
  currentStep = 2;
  _theme: string;
  fields: any;
  definitionOnly: boolean = false;
  selectedFields: any = [];
  _labelPreset: any[] = [];
  _labelPresetFiltered: any[] = [];
  _labelSize: any[] = [];
  _labelSizeFiltered: any[] = [];
  _model: any = {
    BarcodeValues: [],
    LabelSizeID: 0,
    Row: 0,
    Column: 0,
    LabelPresetId: {},
    LabelSize: {},
    numberOfCopy: 1,
    name: "",
    isURL: false
  };
  _gridFields: any[];
  _selectedgridFields: any[] = [];

  maximized: boolean;
  windowMode = true;
  windowState: WindowState = 'default';

  reportCategories: any[] = [];
  reportCategory: any;
  _previewDate: boolean = false;
  _previewObject: any;
  _customSize = ['Yes', 'No'];
  _isCustomSize: boolean = false;
  _gridFieldName: string;
  _showSave: boolean = false;
  _labelPresetObject: LabelPreset;
  SharedModel: any;
  ShowCheckBox: boolean = false;

  accessFrom: string;
  isAsset: boolean = false;
  changedSavedLabelSize: boolean;
  savedLabelSize: any;
  FromBarcodeEditLabel: boolean = false;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('labelType') labelType: ComboBoxComponent;
  @ViewChild('labelSize') labelSize: ComboBoxComponent;
  @ViewChild('custom_size') customSize: ComboBoxComponent;
  @ViewChild('filterBy') filterBy: ComboBoxComponent;
  @ViewChild('kendo_input_Report_Name') name: ElementRef;
  _loggedInAccountId: any;
  _loggedInSiteId: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _themeManager: ThemeManagerService,
    private _sharedService: SharedService,
    private _layoutManager: LayoutManagerService,
    private _labelService: LabelService,
    private _gridFieldsService: GridFieldsService,
    private _reportService: ReportsService,
    private _layoutComponent: LayoutComponent,
    private _securityService: SecurityService,
    private cdr: ChangeDetectorRef,
  ) {
    super();
    this.route.data.subscribe((data: any) => {
      this.accessFrom = data?.accessFrom;
      this.determineIsAsset();
    });
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
  }

  determineIsAsset(): void {
    const isAssetFromRoute = this.accessFrom === 'assets';
    const sharedModel = this._sharedService?.model;
    const innerModel = sharedModel?.model;
    const isAssetFromModel = innerModel?.isAsset ?? sharedModel?.isAsset;
    const accessFromModel = innerModel?.accessFrom ?? sharedModel?.accessFrom;
    const isAssetFromUrl = !!(this.router?.url && this.router.url.includes('/asset'));

    this.isAsset = !!(isAssetFromRoute || isAssetFromModel || accessFromModel === 'assets' || isAssetFromUrl);
  }

  ngOnInit(): void {
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this.SharedModel = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this.determineIsAsset();
    this._loggedInSite();
    this._getLabelPreset();
    this._labelPresetObject = new LabelPreset();
  }

  _loggedInSite() {
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
    if (loggedInAccountSites != "") {
      var accountId = JSON.parse(loggedInAccountSites)[0].accountId;
      var siteId = JSON.parse(loggedInAccountSites)[0].siteId;
      this._loggedInAccountId = accountId;
      this._loggedInSiteId = siteId;
    }
  }

  ngAfterViewInit() {
    this._getdata();
    this.cdr.detectChanges();
    //this._getReportCategories();
  }

  ngOnDestroy(): void {
    this._layoutManager.removeOverlay();
  }

  _getdata() {
    this.determineIsAsset();
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;
    //this._getReportCategories();
    if (this._pageState === PageState.EDIT) {
      this.FromBarcodeEditLabel = true;
      this.SharedModel = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
      this._model.id = this.SharedModel.labelPreset.id;
      this._model.name = this.SharedModel.labelPreset.name;
      this._model.filterBy = this.SharedModel.labelPreset.filterBy;
      this._model.isURL = !!this.SharedModel.labelPreset.isURL;
      this._labelPresetObject.filterBy = this._model.filterBy;

      this._model.LabelSizeID = this.SharedModel.labelPreset.labelSizeID;

      if (this._model.LabelSizeID) {
        this.customSize.value = "No";
        this._isCustomSize = false;
      }
      else {
        this.customSize.value = "Yes";
        this._isCustomSize = true;
        this._model.Width = this.SharedModel.labelPreset.width;
        this._model.Height = this.SharedModel.labelPreset.height;
        this.SetCustomSizeAttributes(false);
      }

      this.labelType.disabled = false;
      this.customSize.disabled = false;
      this.labelSize.disabled = false;
      this._showSave = true;
      // this.filterBy.value = this._model.filterBy;
      // this._reportService.AllCategories().subscribe(
      // (x: any) => {
      //  this.reportCategories = x.filter((x: any) => x.dataSource != null);
      //     let source = this.reportCategories?.find(x => x.dataSource === this.SharedModel.labelPreset.sourceView);
      //     if(source)
      //     {
      //       source.name = source.reportCategoryname;
      //       this._getLabelSize(this.SharedModel.labelPreset.labelSizeID);
      //       this._model.LabelSizeID = this.SharedModel.labelPreset.labelSizeID;

      // this._model.LabelPresetId = this.SharedModel.labelPresets.find((x: any) => x.id == 1);
      //       this.getGridFieldsForEdit(source,this.SharedModel.labelPreset.selectedFields);
      //     }


      //  }
      //);

    }

    if (!this.SharedModel) {
      setTimeout(() => {
        this.name.nativeElement.focus();
        this.labelType.disabled = true;
        this.customSize.disabled = true;
        this.labelSize.disabled = true;
      }, 200);
    }

    this._getReportCategories();
    if (this._pageState === PageState.ADD && this._model && this._model.id > 0) {
      this._model.id = null;
    }

    if (this._pageState === PageState.ADD)
      this.ShowCheckBox = true;
  }


  _closeForm() {
    var closeComponent = {
      component: 'barcodeLabel',
      isClosed: true
    }

    this._active = false;
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
  }


  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove("fullWidthFormForm");
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove("fullWidthFormForm");
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add("fullWidthFormForm");
    }
  }

  _getLabelPreset() {
    // this._labelService.getPresetLabel()
    this._labelService.getSystemPresetLabel(this.isAsset, LabelType.BarcodeLabel).subscribe((x: any[]) => {
      if (this.isAsset) {
        x = x.filter(x => (!x.customLabel && x.name != "Asset with Name" && x.name != "Asset with Model #")
          || x.customLabel);
      }

      this._labelPreset = x;
      this._labelPresetFiltered = x;

      // Brad requirement:
      var elementsNotToDisplay = ["Sales Order"];
      this._labelPresetFiltered = this._labelPresetFiltered.filter(lbl => !elementsNotToDisplay.includes(lbl.name));

      // if(!this.SharedModel)
      // this._labeltypeFocus();
    });
  }

  _getLabelSize(LabelSizeId: any) {
    this._labelService.getLabelSizes().subscribe((x: any[]) => {
      this._labelSize = x;
      this._labelSize = orderBy(this._labelSize, [{ field: "name", dir: "desc" }]);
      this._labelSizeFiltered = this._labelSize;

      if (LabelSizeId) {
        this._model.LabelSize = this._labelSize.find((x: any) => x.id == LabelSizeId);
        this._model.savedLabelSize = { ...this._model.LabelSize };
        this._labelSizeSelectionChange(this._model.LabelSize, true);
      }

      if (!LabelSizeId) {
        this._labelSizeFocus();
      }
    });
  }

  _labeltypeFocus() {
    this.labelType.focus();
    this.labelType.toggle();
    this.labelSize.disabled = true;
  }

  _labelSizeFocus() {
    this.labelSize.focus();
    this.labelSize.toggle();
  }

  _handleLabelTypeFilter(value: any) {
    this._labelPresetFiltered = this._labelPreset.filter((s: any) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  _handleLabelSizeFilter(value: any) {
    this._labelSizeFiltered = this._labelSize.filter((s: any) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  _labelSizeSelectionChange(event: any, FromEditLoad: any) {
    if (event) {
      setTimeout(() => {
        this._model.LabelSize = event;
        this._model.Row = event.rows;
        this._model.Column = event.columns;
        this._model.LabelSizeID = event.id;
        //this._selectedgridFields = [];
        //this.filterBy.value = undefined;
        this._previewDate = false;
        this._previewObject = undefined;

        if (!FromEditLoad) {
          this._getGridFields(this._gridFieldName);
        }

      }, 200);
    }
    if (!event)
      this._showSave = false;

  }

  _labelTypeSelectionChange(event: any) {
    if (event) {
      this._model.LabelPresetId = typeof event === 'object' ? event : (this._labelPreset.find(x => x.id === event) || event);
      this._gridFieldName = this._model.LabelPresetId;
      //if(this._model.LabelSizeID)
      // {
      this._selectedgridFields = [];
      this.filterBy.value = undefined;
      this._previewDate = false;
      this._previewObject = undefined;
      this._getGridFields(this._gridFieldName);
      // }

      setTimeout(() => {
        this.customSize.disabled = false;
        this.customSize.focus();
        this.customSize.toggle();
      }, 200);
    }
    else {
      this._selectedgridFields = [];
      this.filterBy.value = undefined;
      this._previewDate = false;
      this._previewObject = undefined;
      this._showSave = false;
    }
  }

  selectedFieldsWithoutBarcodeImage: any = [];
  GetSelectedGridFields(event: any) {
    this._selectedgridFields = [];
    this._selectedgridFields = event;

    if (this.filterBy.value) {
      var FilterByValue = this._selectedgridFields.filter(x => x.title == this.filterBy.value.title);

      if (FilterByValue.length == 0) {
        this.filterBy.value = undefined;
        this._showSave = false;
      }
    }

    this.selectedFieldsWithoutBarcodeImage = this._selectedgridFields.filter((x: any) => !x.title.includes("(barcode image)"))
    // var x = {
    //   ReportObj: this.getReportObject(),
    //   selectedFields: this._selectedgridFields
    // };
    // this._previewObject = x;
    // this._previewDate = true;
    if (this._selectedgridFields.length > 0) {
      if (this._isCustomSize) {
        if (this._model.Width && this._model.Height) {
          this._previewBarcode();
        }
      }
      else {
        this._previewBarcode();
      }
    }

    this.currentStep = 3;
    // setTimeout(() => {
    //   this.filterBy.focus();
    //   this.filterBy.toggle();
    // }, 200);
  }

  _getGridFields(event: any) {
    let gridFields = event.pageName;
    this._gridFieldsService.getGridFieldsByPage(gridFields).subscribe((x: any) => {
      //this._gridFields = [...x];
      this._getReportCategory(gridFields);
      this._gridFields = this._addBarcodeImageGridField(x);
      this.ShowCheckBox = true;
    });
  }

  getGridFieldsForEdit(event: any, SelectedFields: string) {
    let gridFields = event.pageName;
    this._gridFieldsService.getGridFieldsByPage(gridFields).subscribe((x: any) => {
      //this._gridFields = x;
      this._getReportCategory(gridFields);
      //this._gridFields = this._addBarcodeImageGridField(x);
      let _gridFieldsFiltered = this._addBarcodeImageGridField(x);
      this._selectedgridFields = [];
      let NameFields: any = [];
      let BarcodeFields: any = [];

      if (this.SharedModel.labelPreset.nameField) {
        NameFields = this.SharedModel.labelPreset.nameField.split(",");
      }

      if (this.SharedModel.labelPreset.barcodeField) {
        BarcodeFields = this.SharedModel.labelPreset.barcodeField.split(",");
      }

      let SplitSelectedString = SelectedFields.split(",");

      SplitSelectedString.forEach(obj => {
        if (NameFields.indexOf(obj) != -1) {
          let SelectedGridField = _gridFieldsFiltered.find(x => x.field == obj);
          if (SelectedGridField) {
            SelectedGridField.isSelected = false;
            //this.ShowCheckBox = true;
            //this._gridFields.splice(this._gridFields.indexOf(SelectedGridField), 1);
            this._selectedgridFields.push(SelectedGridField);
          }
        }

        if (BarcodeFields.indexOf(obj) != -1) {
          let SelectedGridField = _gridFieldsFiltered.find(x => x.field == obj && x.title.includes("(barcode image)"));

          if (SelectedGridField) {
            SelectedGridField.isSelected = false;
            this._selectedgridFields.push(SelectedGridField);
          }
        }
      });

      if (this._selectedgridFields.length == 0) {
        SplitSelectedString.forEach(obj => {

          let SelectedGridField = _gridFieldsFiltered.find(x => x.field == obj);

          if (SelectedGridField) {
            //this.ShowCheckBox = true;
            //this._gridFields.splice(this._gridFields.indexOf(SelectedGridField), 1);
            this._selectedgridFields.push(SelectedGridField);
          }
        });
      }

      if (this._selectedgridFields && this._selectedgridFields.length > 0) {
        this._selectedgridFields.forEach((element) => {
          var findElement = _gridFieldsFiltered.find((f) => f.title == element.title);

          if (findElement) {
            if (findElement.title.includes("(barcode image)")) {
              if (_gridFieldsFiltered.find((f) => f.title == element.title)) {
                _gridFieldsFiltered.splice(_gridFieldsFiltered.indexOf(findElement), 1);
              }
            }
            else {
              _gridFieldsFiltered.splice(_gridFieldsFiltered.indexOf(findElement), 1);
            }
          }
        });
      }

      this.selectedFieldsWithoutBarcodeImage = this._selectedgridFields.filter((x: any) => !x.title.includes("(barcode image)"))
      this.filterBy.value = this._selectedgridFields.find(x => x.title == this._model.filterBy);
      if (this.filterBy.value) {
        this._labelPresetObject.selectByField = this.filterBy.value.page + "." + this.filterBy.value.field;
      }

      // var x: any = {
      //   ReportObj: this.getReportObject(),
      //   selectedFields: this._selectedgridFields
      // };
      // this._previewObject = x;
      // this._previewDate = true;
      this._previewBarcode();
      // this._selectedgridFields.forEach((element) => {
      //   var findElement = _gridFieldsFiltered.find((f) => f.id == element.id);
      //   if (findElement) {
      //     findElement.isSelected = true;
      //     _gridFieldsFiltered.splice(_gridFieldsFiltered.indexOf(findElement), 1);
      //   }
      // });
      this._gridFields = [..._gridFieldsFiltered];
      // this.ShowCheckBox = true;
    });
  }

  _getReportCategories() {
    if (this.SharedModel) {
      this._getLabelSize(this.SharedModel.labelPreset.labelSizeID);
      this._model.LabelSizeID = this.SharedModel.labelPreset.labelSizeID;

      if (this.SharedModel.labelPreset.customLabel) {
        this._model.LabelPresetId = this.SharedModel.labelPresets.find((x: any) => x.id == this.SharedModel.labelPreset.relatedLabelPresetID);
      }
      else {
        this._model.LabelPresetId = this.SharedModel.labelPresets.find((x: any) => x.id == this.SharedModel.labelPreset.id);
      }
      this._gridFieldName = this._model.LabelPresetId;
      // let source = this.reportCategories?.find(x => x.dataSource === this.SharedModel.labelPreset.sourceView);
      // if(source)
      // {
      //source.name = source.reportCategoryname;


      //this.getGridFieldsForEdit(source,this.SharedModel.labelPreset.selectedFields);
      this.getGridFieldsForEdit(this._model.LabelPresetId, this.SharedModel.labelPreset.selectedFields);

      //}
    }
    // return this._reportService.AllCategories().subscribe(
    //   (x: any) => {
    //     this.reportCategories = x.filter((x: any) => x.dataSource != null);


    //   }
    // );
  }

  _getReportCategory(code: string) {
    this.reportCategory = this.reportCategories?.find(x => x.reportCategorycode === code);
  }

  _addBarcodeImageGridField(gridFieldList: any[]) {
    for (let i = 0; i <= gridFieldList.length; i++) {
      if (gridFieldList[i]) {
        let imageField = Object.assign('', gridFieldList[i]);
        // imageField.field += "(barcode image)";
        imageField.title += " (barcode image)";
        gridFieldList.splice(i + 1, 0, imageField);
        i++;
      }
    }

    return gridFieldList;
  }

  getReportObject() {
    return {
      name: this._model.name,
      isForecast: 0,
      systemReport: 0,
      siteId: this._loggedInSiteId,
      // reportCategoryId: this.reportCategory ? this.reportCategory.reportCategoryid : null,
      // dataSource: this.reportCategory ? this.reportCategory.dataSource : null,
      //reportCategoryId: this.reportCategory ? this.reportCategory.reportCategoryid : null,
      dataSource: typeof this._model.LabelPresetId === 'object' && this._model.LabelPresetId ? this._model.LabelPresetId.sourceView : (typeof this._model.LabelPresetId === 'string' ? this._model.LabelPresetId : null),
      addAddress: "No",
      addLogo: "No",
      groupBy: "",
      header: "",
      orientation: "Portrait",
      selectedFields: Array.prototype.map.call(this._selectedgridFields, function (item: any) { return item.field; }).join(","),
      definition: this.SharedModel?.labelPreset?.reportDefinition ?? '',
      filterBy: (this._labelPresetObject.filterBy && this._labelPresetObject.filterBy.includes('(barcode image)')) ?
        this._labelPresetObject.selectByField + ('(barcode image)') : (this._labelPresetObject.selectByField || ''),
    };
  }

  maximizeWindow() {
    this.windowState = 'maximized';
    this.maximized = true;
  }

  _nameChange(event: any) {
    event ? this.labelType.disabled = false : this.labelType.disabled = true;

    if (!event)
      this._showSave = false;
  }

  catalogNameChange() {
    if (!this.labelType.disabled) {
      setTimeout(() => {
        this.labelType.focus();
        this.labelType.toggle();
      }, 200);
    }
  }

  _customSizeChange(event: string) {
    if (event === "Yes") {
      setTimeout(() => {
        this._isCustomSize = true;
        this._model.Width = undefined;
        this._model.Height = undefined;
        this._model.LabelSize = {};
        this._getGridFields(this._gridFieldName);
      }, 200);

    }
    else {
      this._isCustomSize = false;
      setTimeout(() => {
        this.labelSize.disabled = false;
        this._getLabelSize(null);
      }, 200);

      if (!event)
        this._showSave = false;
    }
  }

  _filterByChange(event: any) {
    if (event) {
      this._labelPresetObject.filterBy = event.title;
      this._labelPresetObject.selectByField = event.page + "." + event.field;
      this._showSave = true;
      this.currentStep = 4;
      this._previewBarcode();
    }

    if (!event)
      this._showSave = false;
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  _onSave(e: string) {
    if (!this._model.name) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select Name',
        withoutConfirm: true
      });

      return false;
    }

    if (this._previewObject.ReportObj.selectedFields.length == 0) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select at least one field',
        withoutConfirm: true
      });

      return false;
    }

    if (this._isCustomSize) {
      if (!this._model.Width) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select width',
          withoutConfirm: true
        });

        return false;
      }

      if (!this._model.Height) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select height',
          withoutConfirm: true
        });

        return false;
      }
    }

    if (!this.filterBy.value) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select Filter By',
        withoutConfirm: true
      });

      return false;
    }

    if (this._pageState == PageState.EDIT) {
      this._labelPresetObject.id = this._model.id;
    }
    else {
      delete this._labelPresetObject.id;
    }
    this._labelPresetObject.name = this._model.name;
    this._labelPresetObject.relatedLabelPresetID = this._model.LabelPresetId.id;
    this._labelPresetObject.pageName = this._model.LabelPresetId.pageName;
    this._labelPresetObject.sourceView = this._previewObject.ReportObj.dataSource;
    this._labelPresetObject.barcodeField = "";
    this._labelPresetObject.nameField = "";
    this._previewObject.selectedFields.forEach((element: any, index: any) => {
      //this._labelPresetObject.selectByField = element.page+"."+element.field;
      //this._labelPresetObject.nameField = element.page+"."+element.field;
      //this._labelPresetObject.barcodeField = element.page+"."+element.field;
      if (index === this._previewObject.selectedFields.length - 1) {
        if (element.title.includes("(barcode image)")) {
          this._labelPresetObject.barcodeField += element.field;
        }
        else {
          this._labelPresetObject.nameField += element.field;
        }
      }
      else if (index >= 0) {
        if (element.title.includes("(barcode image)")) {
          this._labelPresetObject.barcodeField += element.field + ",";
        }
        else {
          this._labelPresetObject.nameField += element.field + ",";
        }
      }

    });



    this._labelPresetObject.catalog = false;
    this._labelPresetObject.custom = true;
    this._labelPresetObject.twoDimensional = false;
    this._labelPresetObject.rows = this._model.Row;
    this._labelPresetObject.columns = this._model.Column;
    this._labelPresetObject.isPortrait = true;
    this._labelPresetObject.assetrac = true;
    this._labelPresetObject.instock = true;
    this._labelPresetObject.isAsset = this.isAsset;
    this._labelPresetObject.customLabel = true;
    this._labelPresetObject.labelSizeID = this._model.LabelSizeID;
    this._labelPresetObject.selectedFields = this._previewObject.ReportObj.selectedFields;
    this._labelPresetObject.isBarcode = true;
    this._labelPresetObject.isURL = !!this._model.isURL;
    this._labelPresetObject.isQRCode = false;
    this._labelPresetObject.Width = this._model.Width;
    this._labelPresetObject.Height = this._model.Height;
    this._labelPresetObject.labelType = LabelType.BarcodeLabel;
    this.FromBarcodeEditLabel = false;
    if (this._pageState == PageState.ADD) {
      this._labelService.addLabelPreset(this._labelPresetObject).subscribe((response: any) => {
        if (response != null && response["message"] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response["message"],
            withoutConfirm: true
          });
          this._labelPresetObject.id = response.responseId;
          this._labelService.labelAdded.emit(this._labelPresetObject);
          // if (response["close"] != null) {
          //   if (response["close"] == true) {
          //     this._closeForm();
          //   }
          // }
          if (e === "saveAndClose") {
            this._closeForm();
          }
          else if (e === "saveAndCopy") {
            this._model.id = null;
            this._model.name = null;
            delete this._labelPresetObject.id;
            this._pageState = PageState.ADD;
            //this._model = null;
          }
          else if (e === "saveAndNew") {
            this._model.id = null;
            this._model.name = null;
            this._model.labelPresetId = undefined;
            this.labelSize.value = undefined;
            this.labelType.value = undefined;
            this.customSize.value = undefined;
            this.filterBy.value = undefined;
            this._gridFields = [];
            this._selectedgridFields = [];
            this._previewDate = false;
            this._previewObject = undefined;
            delete this._labelPresetObject.id;
            this._pageState = PageState.ADD;
          }
          else if (e === "save") {
            this._pageState = PageState.EDIT;
            this._model.id = response.id;
          }
          else if (e == "saveAndEL") {
            this._pageState = PageState.EDIT;
            this._model.id = response.responseId;
            this._closeForm();
            this.openDesigner(this._model.id);
          }
        }
      });
    }
    else {
      //this.openDesigner(this._model.id);
      if (this._model.id) {
        this._labelPresetObject.id = this._model.id;
      }
      this._labelService.updateLabelPreset(this._model.id, this._labelPresetObject).subscribe((response: any) => {
        if (response != null && response["message"] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response["message"],
            withoutConfirm: true
          });

          // if (response["close"] != null) {
          //   if (response["close"] == true) {
          //     this._closeForm();
          //   }
          // }
          this._labelService.labelPrintUpdated.emit(this._labelPresetObject);
          if (e === "saveAndClose") {
            this._closeForm();
          }
          else if (e === "saveAndCopy") {
            this._model.id = null;
            this._model.name = null;
            delete this._labelPresetObject.id;
            this._pageState = PageState.ADD;
            //this._model = null;
          }
          else if (e === "saveAndNew") {
            this._model.id = null;
            this._model.name = null;
            this._model.labelPresetId = undefined;
            this.labelSize.value = undefined;
            this.labelType.value = undefined;
            this.customSize.value = undefined;
            this.filterBy.value = undefined;
            this._gridFields = [];
            this._selectedgridFields = [];
            this._previewDate = false;
            this._previewObject = undefined;
            delete this._labelPresetObject.id;
            this._pageState = PageState.ADD;
          }
          else if (e === "save") {
            this._pageState = PageState.EDIT;
            //this._model.id = response.id;
          }
          else if (e == "saveAndEL") {
            this._pageState = PageState.EDIT;
            //this._model.id = response.id;
            this._closeForm();
            this.openDesigner(this._model.id);
          }

        }
      });
    }
  }

  _qrDefinition(event: any) {
    this._labelPresetObject.reportDefinition = event;
  }

  openDesigner(reportid: number) {
    this._layoutComponent.openDialogForm(ReportDesignerComponent, PageState.EDIT, { reportId: reportid, IsBarcodeLabelLayout: true });
  }

  _previewBarcode() {
    if (this._selectedgridFields.length == 0) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select at least one field',
        withoutConfirm: true
      });

      return false;
    }

    if (this._isCustomSize) {
      if (!this._model.Width || !this._model.Height) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select Width And Height',
          withoutConfirm: true
        });

        return false;
      }
      //this.SetCustomSizeAttributes(false);
    }

    var x = {
      ReportObj: this.getReportObject(),
      selectedFields: this._selectedgridFields
    };

    this._previewObject = x;
    this._previewDate = true;
  }

  SetCustomSizeWidth(event: any) {
    this._model.Width = event;
  }

  SetCustomSizeHeight(event: any) {
    this._model.Height = event;
  }

  SetCustomSizeAttributes(FromView: boolean) {
    this._model.LabelSizeID = undefined;
    this._model.LabelSize.width = this._model.Width;
    this._model.LabelSize.height = this._model.Height;
    this._model.LabelSize.pageWidth = this._model.Width;
    this._model.LabelSize.pageHeight = this._model.Height;
    this._model.LabelSize.verticalPitch = 0;
    this._model.LabelSize.verticalMargin = 0;
    this._model.LabelSize.horizontalMargin = 0;
    this._model.LabelSize.pageLeftMargin = 0;
    this._model.LabelSize.pageBottomMargin = 0;
    this._model.LabelSize.pageRightMargin = 0;
    this._model.LabelSize.pageTopMargin = 0;
    this._model.LabelSize.columns = 1;
    this._model.LabelSize.rows = 1;
    this._model.Row = 1;
    this._model.Column = 1;
    // this._model.LabelSize.pageWidth= this._model.Width;
    // this._model.LabelSize.pageHeight = this._model.Width;
    // this._model.LabelSize.verticalPitch = 1;
    // this._model.LabelSize.verticalMargin= 0;
    // this._model.LabelSize.horizontalMargin = 0;
    // this._model.LabelSize.columns = 1;
    // this._model.LabelSize.rows = 1;
    // this._model.Row = 1;
    // this._model.Column = 1;
    if (FromView && this._model.Width && this._model.Height && this._selectedgridFields.length > 0) {
      this._previewBarcode();
    }
  }
}
